export const API_BASE_URL = 
    // process.env.REACT_APP_API_BASE_URL_MY_LOCAL
    // process.env.REACT_APP_API_BASE_URL_GIS_DOMAIN_UAT
    process.env.REACT_APP_API_BASE_URL_GIS_DOMAIN_PROD